import React, { useState } from 'react'

export default function SubpageFaqSection({ faq }) {
  if (!faq || !faq.items || faq.items.length === 0) return null

  const [openIndices, setOpenIndices] = useState({})

  const toggleIndex = (index) => {
    setOpenIndices((prev) => ({
      ...prev,
      [index]: !prev[index],
    }))
  }

  return (
    <section
      className="mt-14 sm:mt-20 p-6 sm:p-10 lg:p-12 rounded-[2.5rem] bg-[#DCEEF2] relative overflow-hidden"
      aria-label={faq.title}
    >
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 sm:mb-10">
          <span className="handwritten text-[#2F6F73] text-2xl sm:text-3xl block mb-6">
            Ofte stillede spørgsmål
          </span>
          <h2 className="font-['Plus_Jakarta_Sans'] text-2xl sm:text-3xl lg:text-4xl font-black text-[#36454F] tracking-tight">
            {faq.title}
          </h2>
        </div>

        <div className="space-y-4">
          {faq.items.map((item, index) => {
            const isOpen = Boolean(openIndices[index])
            return (
              <div
                key={item.q}
                className="bg-white rounded-2xl sm:rounded-3xl shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden border border-white/80"
              >
                <button
                  type="button"
                  onClick={() => toggleIndex(index)}
                  className="w-full p-5 sm:p-7 text-left flex items-center justify-between gap-4 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-[#007A53] group"
                  aria-expanded={isOpen}
                >
                  <span
                    className={`font-['Plus_Jakarta_Sans'] text-base sm:text-lg lg:text-xl font-bold transition-colors leading-snug ${
                      isOpen ? 'text-[#007A53]' : 'text-[#36454F] group-hover:text-[#007A53]'
                    }`}
                  >
                    {item.q}
                  </span>
                  <span
                    className={`w-9 h-9 sm:w-10 sm:h-10 rounded-full flex items-center justify-center transition-all duration-300 flex-shrink-0 font-bold ${
                      isOpen
                        ? 'bg-[#007A53] text-white rotate-45'
                        : 'bg-[#DCEEF2] text-[#2F6F73] group-hover:bg-[#007A53] group-hover:text-white'
                    }`}
                    aria-hidden="true"
                  >
                    <i className="fa-solid fa-plus text-sm sm:text-base" />
                  </span>
                </button>

                {isOpen && (
                  <div className="px-5 pb-6 sm:px-7 sm:pb-7 text-[#36454F]/90 text-base sm:text-lg leading-relaxed border-t border-[#DCEEF2]/60 pt-4 animate-in fade-in duration-200">
                    {item.a}
                  </div>
                )}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
